module.exports = __webpack_public_path__ + "img/playBtn2.7ad8b195.png";